import PubSub from "underpub-js";

var QuoteStandard = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-QuoteStandard',
  };

  $.extend(true, this.options, options);

};

QuoteStandard.prototype.init = function () {

  var self = this;

  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);
  self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);
  self.$carousel = self.options.$el.find(`.${self.options.baseClass}__carousel`);

  if (self.$carousel.length) {
    self.$carousel.show();

    self.$items.slick({
      prevArrow: self.$arrowPrev,
      nextArrow: self.$arrowNext,
      fade: true,
    });
  }
};

export default QuoteStandard;